import { render, staticRenderFns } from "./setting-rejection.vue?vue&type=template&id=0690febd&scoped=true"
import script from "./setting-rejection.vue?vue&type=script&lang=js"
export * from "./setting-rejection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0690febd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0690febd')) {
      api.createRecord('0690febd', component.options)
    } else {
      api.reload('0690febd', component.options)
    }
    module.hot.accept("./setting-rejection.vue?vue&type=template&id=0690febd&scoped=true", function () {
      api.rerender('0690febd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-page/components/form-b/setting-rejection.vue"
export default component.exports